import { Grid } from '@mui/material/';

import { useT } from 'UI/lib';

const SkillExpertiseEmployeePendingTooltip = () => {
  const t = useT();

  return (
    <Grid container flexDirection="column" justifyContent="center">
      <Grid item>{t('restrict:skill_expertise_tooltip_employee_pending_approval')}</Grid>
    </Grid>
  );
};

export default SkillExpertiseEmployeePendingTooltip;
